/* eslint-disable import/prefer-default-export */

export function buildPath(path, params) {
  return path.replace(/\{(\w+)\}/g, (_, key) => {
    if (params[key] === undefined) {
      throw new Error(`Missing value for URL parameter: ${key}`);
    }
    return encodeURIComponent(params[key]);
  });
}

export function modulePricingUniqueKey(price) {
  return `${price.module_id}-${price.comm_id}-${price.area_code}`;
}
